import React from 'react'
import { I18n } from 'react-redux-i18n'

const formatPrice = (price) => {
  if (price.toString().indexOf('.') !== -1) {
    return price.toFixed(2).replace('.', ',')
  }

  return price
}

/**
 * Plan Price Cards
 * @param {object} props
 * @param {object} props.plan
 * @param {boolean} props.isSelected
 * @param {boolean} props.isCurrent Indica si es el contratado actualmente
 */
const PlanPriceCard = (props) => {
  const {
    isSelected = false, plan = {}, isCurrent = false,
    onChange = null
  } = props
  const { label = '', prices = {} } = plan
  const { companyPlanFee = 0 } = prices

  return (
    <div
      className={`plan_price_card ${isSelected ? 'price_selected' : ''}`}
      onClick={isSelected ? null : () => onChange(plan)}
    >
      {
        isCurrent
          ? (
            <div className='plan_price_card-current'>
              {I18n.t('price_plan_current')}
            </div>
          )
          : null
      }
      <div className='plan_price_card-content'>
        <div className='plan_price_card-title'>
          {
            I18n.t(label)
          }
        </div>
        <div className='plan_price_card-price_info'>
          {I18n.t('price_plan_eur_month', { price: formatPrice(companyPlanFee) })}
        </div>
      </div>
    </div>
  )
}

export default PlanPriceCard
